import * as React from 'react';

import { IRouter, Link } from 'react-router';
import { url, safeJsonParse, createFetchOptions } from '../../util';

import { IVet } from '../../types';

interface IVetsPageState {
  vets: IVet[];
}

export default class VetsPage extends React.Component<void, IVetsPageState> {
  constructor(props?: any) {
    super(props);

    this.state = { vets: [] };
  }

  componentDidMount() {
    const requestUrl = url('api/vets');

    fetch(requestUrl, createFetchOptions())
      .then(response => safeJsonParse(response))
      .then(vets => { 
        console.log('vets', vets); 
        // Handle case where response is an error object
        if (vets && Array.isArray(vets)) {
          this.setState({ vets }); 
        } else {
          console.error('Invalid vets response:', vets);
          this.setState({ vets: [] });
        }
      })
      .catch(error => {
        console.error('Error loading vets:', error);
        this.setState({ vets: [] });
      });
  }

  render() {
    const { vets } = this.state;

    if (!vets) {
      return <h2>Veterinarians</h2>;
    }

    return (
      <span>
        <h2>Veterinarians</h2>
        <table className='table table-striped'>
          <thead>
            <tr>
              <th>Name</th>
              <th>Specialties</th>
            </tr>
          </thead>
          <tbody>

            {vets.map(vet => (
              <tr key={vet.id}>
                <td>{vet.firstName} {vet.lastName}</td>
                <td>{vet.specialties.length > 0 ? vet.specialties.map(specialty => specialty.name).join(', ') : 'none'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </span>
    );
  }
}
